export default __webpack_public_path__ + "static/Graphik-BoldItalic-Web-3192d25adf84029e4934e9ccbeb7f425.svg";